import * as $ from "jquery";

/**
 * similar to ajx call, but use XMLHttpRequest directly to get binary data
 * @param settings
 */
function downloadBlob(settings: JQueryAjaxSettings) : JQueryPromise<Blob> {
    let deferred = $.Deferred();
    let req = new XMLHttpRequest();
    req.open(settings.type, settings.url, true);

    if (settings.dataType) {
        req.overrideMimeType(settings.dataType);
    }
    if (settings.headers) {
        _.each(settings.headers, (val, key) => {
            req.setRequestHeader(key, val);
        });
    }
    req.responseType = "blob";
    if (settings.beforeSend) {
        settings.beforeSend(null, settings);
    }
    req.onreadystatechange = () => {
        if (req.readyState == XMLHttpRequest.DONE) {
            if (req.status >= 200 && req.status < 300 && req.response) {
                deferred.resolve(req.response);
            } else {
                deferred.reject(req);
            }
        }
    };
    req.send();
    return deferred;
}

export default downloadBlob;



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/downloadBlob.ts